import { GET_METRICS_SUCCESS } from '../apiActions/metricsApiActions';

const initialState = {
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_METRICS_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return state;
  }
};
